import React from "react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../App";
import { Card, CardContent } from "./ui/card";
import { Button } from "./ui/button";
import { Wind, Waves } from "lucide-react";

const CategoryCards = () => {
  const { language } = useLanguage();
  const navigate = useNavigate();

  const categories = [
    {
      id: "kitesurf",
      slug: "/lessons/kitesurf-lessons",
      name: { en: "Kitesurf Lessons", es: "Lecciones de Kitesurf", de: "Kitesurf-Unterricht", fr: "Cours de Kitesurf" },
      description: { en: "Professional IKO certified instruction for all levels", es: "Instruccion profesional certificada IKO para todos los niveles", de: "Professioneller IKO-zertifizierter Unterricht fur alle Levels", fr: "Instruction professionnelle certifiee IKO pour tous niveaux" },
      icon: Wind,
      image: "https://images.unsplash.com/photo-1690681200064-0302728b3572",
      color: "from-blue-600 to-cyan-500",
    },
    {
      id: "surf",
      slug: "/lessons/surf-lessons",
      name: { en: "Surf Courses", es: "Cursos de Surf", de: "Surf-Kurse", fr: "Cours de Surf" },
      description: { en: "Catch your first wave in Dakhla", es: "Atrapa tu primera ola en Dakhla", de: "Fange deine erste Welle in Dakhla", fr: "Attrapez votre premiere vague a Dakhla" },
      icon: Waves,
      image: "https://customer-assets.emergentagent.com/job_acc6b5c6-4c76-49ba-a1fd-498cb047a8ad/artifacts/7txvwmsl_IMG_4362.jpeg",
      color: "from-orange-500 to-yellow-500",
    },
    {
      id: "wingfoil",
      slug: "/lessons/wingfoil-lessons",
      name: { en: "Wing Foil Lessons", es: "Lecciones de Wing Foil", de: "Wing Foil Unterricht", fr: "Cours de Wing Foil" },
      description: { en: "Professional Wingfoil courses in Dakhla", es: "Cursos profesionales de Wingfoil en Dakhla", de: "Professionelle Wingfoil-Kurse in Dakhla", fr: "Cours professionnels de Wingfoil a Dakhla" },
      icon: Wind,
      image: "https://images.unsplash.com/photo-1666175497168-48b72df461cf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwzfHx3aW5nZm9pbCUyMHdpbmclMjBmb2lsJTIwd2F0ZXIlMjBzcG9ydHxlbnwwfHx8fDE3NzM4ODY5MTJ8MA&ixlib=rb-4.1.0&q=85",
      color: "from-purple-600 to-pink-600",
    },
  ];

  return (
    <section id="lessons" className="py-24 bg-gradient-to-b from-white to-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Services</h2>
          <p className="text-xl text-gray-600">Choose your adventure in Dakhla</p>
          <div className="w-24 h-1 bg-gradient-to-r from-blue-600 to-cyan-500 mx-auto mt-4"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {categories.map((category) => (
            <Card
              key={category.id}
              className="group relative overflow-hidden border-2 hover:border-blue-400 transition-all hover:shadow-2xl transform hover:-translate-y-2 cursor-pointer"
              onClick={() => navigate(category.slug)}
              data-testid={`category-card-${category.id}`}
            >
              <div className="h-64 bg-cover bg-center relative" style={{ backgroundImage: `url(${category.image})` }}>
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4">
                  <div className={`w-12 h-12 bg-gradient-to-r ${category.color} rounded-full flex items-center justify-center mb-3`}>
                    <category.icon className="h-6 w-6 text-white" />
                  </div>
                  <h3 className="text-2xl font-bold text-white">{category.name[language]}</h3>
                </div>
              </div>
              <CardContent className="p-6">
                <p className="text-gray-700 mb-4 leading-relaxed">{category.description[language]}</p>
                <Button className={`w-full bg-gradient-to-r ${category.color} hover:opacity-90 text-white`}>
                  View Options
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategoryCards;
